/**
 * Created by gusenlin on 2018/4/28.
 */
//解析审批历史记录的数据
import { operationType, statusMap } from '@/lookups/history-status.js';
import Vue from 'vue';
import { formatDate } from '@/utils/date';
import { formatMoney } from '@/utils/money';

const historyStatusEnum = {
  '-1009': 'WAITING',
  1001: 'SUBMIT', //提交
  1002: 'WITHDRAW', //撤回
  2001: 'PASS', //审批通过
  2002: 'REJECT', //审批驳回
  2003: 'REJECT', //单笔驳回
  3001: 'PASS', //审核通过
  3002: 'REJECT', //审核驳回
  3004: 'PASS', //财务预检
  3003: 'PASS', //收到
  4003: 'PASS', //信用付款
  2012: 'SUBMIT', //评论
  16001: 'WITHDRAW', // 合同暂挂
  16002: 'REJECT', // 合同取消
  8013: 'REJECT', //批量驳回/删除付款行
};

const statusStyle = {
  DEFAULT: { background: '#32CD91' }, //8C96B4
  WAITING: { background: '#fff', border: '1px solid #dadada', left: '-5px' },
  WITHDRAW: { background: 'rgb(235, 169, 69)' },
  SUBMIT: { background: '#1978D2' },
  PASS: { background: '#32CD91' },
  REJECT: { background: '#FA6478' },
};

const paymentHistoryStatusEnum = {
  5000: 'SUBMIT', //提交
  5001: 'WITHDRAW', //撤回
  5002: 'PASS', //审批通过
  5003: 'REJECT', //审批驳回
  5004: 'SUBMIT',
};

export function paymentHistory(approvalHistoryDTOs) {
  function paymentStatusMap() {
    return {
      5000: window.$t('workflow-1.key155', { cm: 'APP还款提交' }),
      5001: window.$t('workflow-1.key156', { cm: '现金还款提交' }),
      5002: window.$t('workflow-1.key157', { cm: '财务收款通过' }),
      5003: window.$t('workflow-1.key158', { cm: '财务收款驳回' }),
      5004: window.$t('workflow-1.key159', { cm: '报销单还款提交' }),
    };
  }

  function getPaymentCircleColor(status) {
    let historyStatus = paymentHistoryStatusEnum[status];
    let color = statusStyle['DEFAULT'];
    if (historyStatus) {
      color = statusStyle[historyStatus];
    }
    return color;
  }

  let arr = [];

  if (approvalHistoryDTOs) {
    approvalHistoryDTOs.forEach((data) => {
      let remark = '',
        userInfo = '';
      if (data.operationDetail && data.operationDetail != '') {
        remark = data.operationDetail;
      }
      if (data.operator) {
        if (data.operator.fullName != '') {
          userInfo = data.operator.fullName + ' ' + data.operator.employeeID;
        }
      }
      var item = {
        approveType: paymentHistoryStatusEnum[data.operation],
        circleColor: getPaymentCircleColor(data.operation),
        operationCreditRule: data.operationCreditRule,
        historyId: data.id,
        status: data.operation,
        date: data.lastModifiedDate,
        time: formatDate(data.lastModifiedDate),
        operation: paymentStatusMap()[data.operation],
        userInfo: userInfo,
        payAmount: '',
        remark: remark,
      };
      arr.push(item);
    });
  }

  return arr;
}

//审批历史的代理人取值逻辑
function getProxyApprovers(proxyApprovers) {
  let proxyApproversStr = '';
  if (proxyApprovers && proxyApprovers.length > 0) {
    proxyApprovers.forEach((proxy) => {
      proxyApproversStr =
        proxyApproversStr +
        (proxyApproversStr == ''
          ? proxy.fullName + ' ' + proxy.employeeID
          : ',' + proxy.fullName + ' ' + proxy.employeeID);
    });
  }
  return proxyApproversStr;
}

//等待XXX审批的审批人列表显示逻辑
export function getApproverText(approvalChain) {
  let approverName = '';
  if (approvalChain.approverName) {
    approverName = `${approvalChain.approverName}${
      approvalChain.approverEmployeeID ? ` ${approvalChain.approverEmployeeID}` : ''
    }`;
    if (approvalChain.proxyApprovers) {
      let proxyApprovers = getProxyApprovers(approvalChain.proxyApprovers);
      approverName = window.$t('workflow-1.key205', {
        arg1: approverName,
        arg2: proxyApprovers,
        cm: '{arg1}（代理人：{arg2}）',
      });
    }
  }
  return approverName;
}

export function analysisHistory(approvalChain, approvalChains, approvalHistoryDTOs, childrens, currencyCode, amount) {
  let approveHistory = [];
  let translate = {
    $t: Vue.i18n.translate,
  };
  let nodeListOIDS = [];
  try {
    let statusMapInstance = statusMap(translate);
    let operationTypeInstance = operationType(translate);
    let approverNameArr, approverNameSingal;
    let chain;
    if (approvalChain) {
      chain = approvalChain;
      approverNameArr = getApproverText(approvalChain);
    }

    let isSameApprovalChainsNode = true;
    let copyApprovalChains = [];
    if (approvalChains) {
      approverNameArr = [];
      approvalChains.forEach(function (data) {
        approverNameSingal = getApproverText(data);
        approverNameSingal && approverNameArr.push(approverNameSingal);
      });
      const nodeList = approvalChains && approvalChains.map((item) => item.ruleApprovalNodeOID);
      const result = nodeList && [...new Set(nodeList)];
      if (result && result.length === 1) {
        isSameApprovalChainsNode = true;
      } else {
        isSameApprovalChainsNode = false;
      }
      chain = approvalChains[0];

      const map = {};
      const myArr = [];
      for (let i = 0; i < approvalChains.length; i++) {
        if (!map[approvalChains[i].ruleApprovalNodeOID]) {
          myArr.push({
            ruleApprovalNodeOID: approvalChains[i].ruleApprovalNodeOID,
            data: [approvalChains[i]],
          });
          map[approvalChains[i].ruleApprovalNodeOID] = approvalChains[i];
        } else {
          for (let j = 0; j < myArr.length; j++) {
            if (approvalChains[i].ruleApprovalNodeOID === myArr[j].ruleApprovalNodeOID) {
              myArr[j].data.push(approvalChains[i]);
              break;
            }
          }
        }
      }
      copyApprovalChains = myArr;
    }
    if (chain) {
      var item = {
        approveType: getState(''),
        circleColor: getCircleColor('-1009'),
        operationCreditRule: '',
        historyId: null,
        status: '-1009',
        date: chain.lastModifiedDate,
        time: formatDate(chain.lastModifiedDate),
        operationCode: isSameApprovalChainsNode ? 'wait' : 'parallel',
        operation: window.$t('workflow-1.key152', { cm: '等待处理' }),
        remark: isSameApprovalChainsNode ? approverNameArr : copyApprovalChains,
        showMine: false,
        ruleApprovalNodeOID: chain.ruleApprovalNodeOID,
      };
      chain.ruleApprovalNodeOID && nodeListOIDS.push(chain.ruleApprovalNodeOID);
      approveHistory.push(item);
    }

    if (approvalHistoryDTOs) {
      const showApprovalUserEmployeeId = Vue.prototype.COMMON.getOption(
        'approvalFunctionOpt.showApprovalUserEmployeeId'
      );
      approvalHistoryDTOs.forEach((data) => {
        let item = historyItem(
          data,
          statusMapInstance,
          operationTypeInstance,
          currencyCode,
          amount,
          null,
          showApprovalUserEmployeeId
        );
        data.ruleApprovalNodeOID && nodeListOIDS.push(data.ruleApprovalNodeOID);
        item['ruleApprovalNodeOID'] = data.ruleApprovalNodeOID;
        approveHistory.push(item);
      });
    }

    if (childrens) {
      childrens.forEach((children) => {
        if (children.printable) {
          if (children.approvalHistoryDTOs) {
            children.approvalHistoryDTOs.forEach((data) => {
              //父单审核通过后的，合并子单的审批状态，排除审核驳回，加签
              if (
                data.operation >= 3001 &&
                data.operation != 4011 &&
                data.operation != 5009 &&
                data.operation != 3002
              ) {
                let item = historyItem(
                  data,
                  statusMapInstance,
                  operationTypeInstance,
                  children.currencyCode,
                  children.realPaymentAmount,
                  true,
                  true
                );
                data.ruleApprovalNodeOID && nodeListOIDS.push(data.ruleApprovalNodeOID);
                item['ruleApprovalNodeOID'] = data.ruleApprovalNodeOID;
                approveHistory.push(item);
              }
            });
          }
        } else {
          if (children.approvalHistoryDTOs) {
            children.approvalHistoryDTOs.forEach((data) => {
              //父单审核通过后的，合并子单的审批状态，排除审核驳回，加签
              if (data.operation > 3001 && data.operation != 5009 && data.operation != 3002) {
                let item = historyItem(
                  data,
                  statusMapInstance,
                  operationTypeInstance,
                  children.currencyCode,
                  children.realPaymentAmount,
                  true,
                  true
                );
                data.ruleApprovalNodeOID && nodeListOIDS.push(data.ruleApprovalNodeOID);
                item['ruleApprovalNodeOID'] = data.ruleApprovalNodeOID;
                approveHistory.push(item);
              }
            });
          }
        }
      });
    }
    return approveHistory;
  } catch (e) {
    return approveHistory;
  }
}

function payAmount(operation, currencyCode, amount) {
  if (operation == '4001' && amount) {
    return currencyCode + ' ' + formatMoney(amount, 2, '');
  }
  return '';
}

function getCircleColor(status) {
  let historyStatus = historyStatusEnum[status];
  let color = statusStyle['DEFAULT'];
  if (historyStatus) {
    color = statusStyle[historyStatus];
  }
  return color;
}

function getState(status) {
  let historyStatus = historyStatusEnum[status];
  if (!historyStatus) {
    historyStatus = 'DEFAULT';
  }
  return historyStatus;
}

function getApportionmentFlag(apportionmentFlag) {
  if (apportionmentFlag) {
    return window.$t('workflow-1.key161', { cm: '分摊审批' });
  } else {
    return '';
  }
}

function historyItem(
  data,
  statusMapInstance,
  operationTypeInstance,
  currencyCode,
  amount,
  hasChridren,
  showEmployeeID
) {
  let remark = '',
    remarkName = '',
    userInfo = '',
    mine = false,
    historyItemDetail = [];

  if (data.operationDetail && data.operationDetail != '') {
    remark = data.operationDetail;
    if (data.operationDetail === 'SYSTEM_AUTO_INVOICE') {
      remark = window.$t('workflow-1.key162', { cm: '系统自动开票' });
    }
    // 知会节点新数据有noticeUsers
    if (data.operation === 2017 && data?.noticeUsers?.length) {
      userInfo = data.noticeUsers.map((noticeUser) => {
        return `${noticeUser.fullName} ${!showEmployeeID ? '' : noticeUser.employeeID}`;
      });
    }
  }
  if (data.operator) {
    if (data.operator.fullName != '') {
      userInfo =
        data.operator.fullName +
        ' ' +
        (data.operator.employeeID == null || !showEmployeeID ? '' : data.operator.employeeID);
      if (data.chainApprover && data.operator.employeeID != data.chainApprover.employeeID) {
        if ([3001, 3002].includes(data.operation)) {
          // 审核通过 审核驳回
          userInfo = window.$t('workflow-1.key206', {
            arg1: userInfo,
            arg2: data.chainApprover.fullName,
            arg3: showEmployeeID ? data.chainApprover.employeeID : '',
            cm: '{arg1} (代 {arg2} {arg3} 审核)',
          });
        } else {
          userInfo = window.$t('workflow-1.key172', {
            arg1: userInfo,
            arg2: data.chainApprover.fullName,
            arg3: showEmployeeID ? data.chainApprover.employeeID : '',
            cm: '{arg1} (代 {arg2} {arg3} 审批) ',
          });
        }
      }
    }
    //后台返回系统概念的名称了，不用前端写死了
    if (data.operator.userOID == '00000000-0000-0000-0000-000000000000') {
      userInfo = data.operator && data.operator.fullName;
    }
    //报销单的逻辑
    if (hasChridren) {
      userInfo = operationTypeInstance[data.operationType] || userInfo;
    }

    let { operation, currentApplicantOID, operatorOID, currentApplicant = {} } = data;

    if (operation === 1001 && currentApplicantOID && currentApplicantOID !== operatorOID) {
      let { fullName = '', employeeID = '' } = currentApplicant;
      userInfo = window.$t('workflow-1.key173', {
        arg1: userInfo,
        arg2: fullName,
        arg3: showEmployeeID ? employeeID : '',
        cm: '{arg1} (代 {arg2} {arg3} 制单) ',
      });
    }
  }

  let operatorName = '';
  // countersignType 表示加签人审批方式，目前有0，1，2三种情况
  if ([2001, 3001].includes(data.operation) && (data.countersignType || data.countersignType === 0)) {
    operatorName = window.$t('workflow-1.key153', { cm: '加签' });
  }
  let operation = data.operationDescription;
  if (!data.operationDescription) {
    operation = statusMapInstance[data.operation];
  }

  //加签，要标明自己，加签不需要显示自己个人信息，直接显示备注
  if (data.operation === 5009) {
    userInfo = data.operator.fullName + ' ' + (data.operator.employeeID == null ? '' : data.operator.employeeID);
    if (data.operator && data.operator.fullName) {
      operatorName = data.operator.fullName;
    }
    mine = false;
  }
  // 是否显示回复按钮 需要结合组件内的 props 值 3006审核人通知 2010审批人通知
  let isShowReplyBtn =
    [3006, 2010, 8009].includes(data.operation) || (data.operation === 8001 && ![1002, 5001].includes(data.entityType));
  // 是否为银行回单的节点 然后在这里做特殊处理
  let bankReceiptFileUrl;
  if (data.operation === 4026) {
    let { operationDetail } = data;
    if (operationDetail && operationDetail.split('|')[0]) {
      remark = operationDetail.split('|')[0];
    }
    if (operationDetail && operationDetail.split('|')[1]) {
      bankReceiptFileUrl = operationDetail.split('|')[1];
    }
  }
  // 显示操作人
  if ((userInfo && userInfo != '' && ![5005, 2000].includes(data.operation)) || [2017, 5009].includes(data.operation)) {
    // 如果配置的不展示审批节点，置空。
    historyItemDetail.push({
      nodeName: Vue.prototype.COMMON.getOption('approvalFunctionOpt.showApprovalNodeName')
        ? data.ruleApprovalNodeName
        : '',
      remark: userInfo,
    });
  }
  // 退回/跳转/转交
  switch (data.operation) {
    case 2013:
      remarkName = window.$t('workflow-1.key103', { cm: '退回意见' });
      historyItemDetail.push({
        nodeName: window.$t('workflow-1.key187', { cm: '退回至' }),
        remark: data.approvalGoBackNodeName,
      });
      break;
    case 9001:
      historyItemDetail.push({
        nodeName: window.$t('workflow-1.key188', { cm: '跳转至' }),
        remark: data.approvalSkipNodeName,
      });
      break;
    case 5010: // 转交
    case 5011: // 管理员转交
      remarkName = window.$t('workflow-1.key87', { cm: '转交理由' });
      historyItemDetail.push({
        nodeName: window.$t('workflow-1.key189', { cm: '转交至' }),
        remark: `${data.transferrePerson.fullName}${showEmployeeID ? ` ${data.transferrePerson.employeeID}` : ''}`,
      });
      break;
    case 3013:
      remark = '退回原因'; // 用于退回原因入口显示，前端不会显示这个remark
      break;
    case 1008:
      historyItemDetail.push({
        remark: window.$t('workflow-1.key321', { arg1: data.remark, cm: '报废原因：{arg1}' }),
      });
      break;
  }
  var item = {
    historyId: data.id,
    approveType: getState(data.operation),
    circleColor: getCircleColor(data.operation),
    operationCreditRule: data.operationCreditRule,
    status: data.operation,
    date: data.createdDate,
    time: formatDate(data.createdDate),
    operation: operatorName + ' ' + operation + getApportionmentFlag(data.apportionmentFlag),
    userInfo: userInfo,
    payAmount: payAmount(data.operation, currencyCode, amount),
    remark: remark,
    showMine: mine,
    showReplyFlag: data.operation == 3006 || data.operation === 2010,
    showRepliedFlag: data.operation === 8001,
    showReplyBtn: isShowReplyBtn,
    showApplicationChangeLog: Boolean(data.operation === 1003 && data.operationDetail),
    entityOID: data.entityOID,
    entityType: data.entityType,
    operatorOID: data.operatorOID,
    operationDescription: operation,
    operationCode: data.operation,
    operationHistoryList: data.operationHistoryList,
    attachmentDTOList: data.attachmentDTOList,
    historyDiscussDetail: data.approvalDiscussDTO && data.approvalDiscussDTO.historyDiscussDetail,
    bankReceiptFileUrl: bankReceiptFileUrl,
    discussUsers: Vue.prototype.COMMON.getValue(data, 'approvalDiscussDTO.discussUsers') || [],
    remarkName,
    refApprovalChainCreateType: data.refApprovalChainCreateType,
    historyItemDetail,
    showFailReasonBtn: Boolean(data.operation === 2021 && data.operationDetail) || data.operation === 3013,
    reason: data.remark,
  };
  return item;
}
